import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormHelperText,
  Stack,
  TextField,
  Tooltip,
  Typography,
  createFilterOptions,
} from "@mui/material";
import React from "react";
import {
  InputControl,
  PageListLayout,
  ServerPaginatedtable,
  DeleteModal,
  LimitedTag,
  CustomeDialog,
} from "../../../shared";
import AddIcon from "@mui/icons-material/Add";
import { createColumnHelper } from "@tanstack/react-table";
import checkIcon from "../../../assets/images/Icons/check.svg";
import warningIcon from "../../../assets/images/Icons/alert_orange.svg";
import { useTemplates } from "../hooks/useTemplates";
import { SimpleMenuTempDelete } from "../../../shared/components/SimpleMenuTempDelete";
import { DeleteAlertDialog } from "../components/DeleteAlertDialog";
import { GenerateTemplates } from "./GenerateTemplates";
import { CustomDialogTemplate } from "../../../shared/components/CustomDialogTemplate";
import { CommonTab } from "./CommonTab";
import { useLocation, useNavigate } from "react-router-dom";
import { navigateBasedOnUserType } from "../../../utils";
import { CreateDateAssignTab } from "./CreateDateAssignTab";
import { RegenerateDialog } from "../components";
import { CreateStoreAssignTab } from "./CreateStoreAssignTab";
import { useStores } from "../../Store/hooks";
import { BatchSplitDialog } from "./BatchSplitDialog";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";

export const TemplatesList = () => {
  const { listQuery: storeListData } = useStores({ isList: true });
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        Item: {
          message: "The recipes field is required.",
          required: true,
          rule: (value) => {
            if (value?.length <= 0) return false;
            else return true;
          },
        },
      },
    })
  );

  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");

  const navigate = useNavigate();
  const {
    listQuery: { isLoading, data },
    listQuery,
    templates,
    onSearchHandler,
    setPagination,
    pagination,
    sorting,
    setSorting,
    disableclearButton,
    onClearFilter,
    selectStatus,
    selectSchedule,
    deleteInfo,
    onDelete,
    resetDeleteInfo,
    confirmDelete,
    storeLists,
    StoreValuesHandler,
    categorylistQuery,
    onSave,
    handleOpenClick,
    updateTableData,
    onChangeFilter,
    handleRecipes,
    state,
    handleOptionChangeRecipe,
    handleOptionChangeRecipeBatch,
    onSearchChange,
    templateDetails,
    batchFilter1,
    handleBack,
    handleCustomTableChange,
    onChange,
    onNameCreateSubmit,
    generateBatch,
    createTemplateName,
    copyBatch,
    searchHandler,
    isCreateVisible,
    isEditable,
    isDeletable,
    isCopyTemplate,
    tableData,
    moduleName,
    search,
    handleCustomFieldChange,
    recipelistQuery,
    onChangeMultipleDate,
    onSaveCustomDays,
    onDeleteTagSelect,
    dropdownListQuery,
    handleRepeatOptionChange,
    onChangeHandler,
    WeekDaysOptionChange,
    OptionChange,
    DaysOfWeekOptionChange,
    onChangeDate,
    onChangeSceduler,
    onChangeYear,
    RadioButtonChange,
    handleDayClick,
    monthOptionChange,
    weekDaysOptionChange,
    weekOfMonthOptionChange,
    onSubmits,
    handleClickUpdateOpen,
    onChangeEffectiveDate,
    setTemplates,
    handleStoreAssignDialog,
    handleAlertClickOpen,
    handleCreateDateAssign,
    handleNextButton,
    globalData,
    selectedDates,
    setSelectedDates,
    allDates,
    allProductionDates,
    selectedProductionDates,
    setSelectedProductionDates,
    templateProductionDaysDetails,
    handleDeleteScheduledDatesDialog,
    unselectedProductionDates,
    setUnselectedProductionDates,
    templateProductionDaysList,
    handleBatchSplitUpdate,
    selectedIndex,
    setSelectedIndex,
    setEditedMap,
    setFocusedField,
    editedMap,
    focusedField,
    updateBatchSplit,
    handleAddBatch,
    handleDeleteBatch,
    handleDeleteBatchDialog,
    hasAnyBatchError,
    hasLastBatchWeightZero,
  } = useTemplates({
    list: true,
    dropdownlist: true,
    isList: true,
  });

  const dateValidator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        Item: {
          message: "Each date must be today or in the future.",
          required: true,
          rule: (values) => {
            return (
              values &&
              values?.every(
                (value) =>
                  value && moment(value)?.isSameOrAfter(moment(), "day")
              )
            );
          },
        },
      },
    })
  );
  // if (listQuery.isLoading) {
  //   return <Loader />;
  // }
  const handleSubmit = (type, id) => {
    if (dateValidator.current.allValid()) {
      if (id) {
        handleClickUpdateOpen(type, id);
      } else {
        onSubmit();
      }
    } else {
      dateValidator.current.showMessages();
      forceUpdate(1);
    }
  };
  const onSubmit = () => {
    if (validator.current.allValid()) {
      onNameCreateSubmit();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };
  const onCreateSubmit = (type) => {
    if (validator.current.allValid()) {
      onSave(type);
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };
  const storeList = (stores) => {
    if (stores) {
      if (stores?.length < 3) {
        return stores.map((data) => (
          <Chip size="small" variant="outlined" color="gray" label={data} />
        ));
      } else {
        const limitedChips = [];
        const moreStores = [];
        for (var i = 0; i < stores?.length; i++) {
          if (i < 2) {
            var data = stores[i];
            const chip = (
              <Chip size="small" variant="outlined" color="gray" label={data} />
            );
            limitedChips.push(chip);
          } else {
            let data = stores[i];
            moreStores.push(data);
          }
        }
        const moreChip = (
          <Tooltip
            title={
              <React.Fragment>
                {moreStoreTooltipList(moreStores)}
              </React.Fragment>
            }
          >
            <Chip
              size="small"
              variant="more"
              label={stores?.length - 2 + " more stores"}
            />
          </Tooltip>
        );
        limitedChips.push(moreChip);
        return limitedChips;
      }
    }
  };

  const filter = createFilterOptions();

  const moreStoreTooltipList = (stores) => {
    return (
      <ul>
        {stores.map((item) => (
          <li>{item}</li>
        ))}
      </ul>
    );
  };

  const columnHelper = createColumnHelper(data);

  const columns = [
    columnHelper.accessor("template_name", {
      id: "name",
      header: "Template Name",
    }),

    columnHelper.accessor("batches", {
      id: "no_of_batches",
      header: "No Of Batches",
    }),

    columnHelper.accessor("scheduled", {
      header: "Scheduled",
      cell: ({ row }) => {
        let icons, colors, labels;

        if (row.original.scheduled === 1) {
          icons = checkIcon;
          colors = "#0B815A";
          labels = "Scheduled";
        } else {
          icons = warningIcon;
          colors = "#E79A53";
          labels = "Not Scheduled";
        }
        return (
          <Stack direction="row" alignItems="center" gap={1}>
            <img src={icons} alt={labels} />
            <Typography color={colors}>{labels}</Typography>
          </Stack>
        );
      },
    }),

    columnHelper.accessor("status", {
      header: "Status",

      cell: ({ row }) => {
        return row?.original.status ? (
          <Chip size="small" color="primary" variant="filled" label="ACTIVE" />
        ) : (
          <Chip size="small" color="gray" label="INACTIVE" />
        );
      },
    }),

    columnHelper.accessor("stores", {
      enableSorting: false,
      header: () => "Stores",
      hidden: isStoreAdmin,
      cell: (props) => {
        const { row } = props;
        return row?.original?.stores?.length > 0 ? (
          <Stack direction="row" gap="8px">
            {storeList(row?.original?.stores)}
          </Stack>
        ) : (
          <Stack direction="row" alignItems="center" gap={1}>
            <img src={warningIcon} alt="alert icon" />
            <Typography color="#E79A53">No Store Selected</Typography>
          </Stack>
        );
      },
    }),

    columnHelper.display({
      id: "actions",
      cell: (props) => {
        const { row } = props;
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            gap="8px"
          >
            {(isCopyTemplate || isEditable || isDeletable) && (
              <SimpleMenuTempDelete
                row={row}
                copyAction={() =>
                  handleOpenClick(true, row.original.template_id)
                }
                handleDeleteModal={() => onDelete(row.original)}
                isEditable={isEditable}
                isDeletable={isDeletable}
                isCopyTemplate={isCopyTemplate}
              />
            )}
            <img alt="details" src="/icons/arrow_forward.png" />
          </Stack>
        );
      },
    }),
  ];

  const breadcrumbs = [
    <Typography key="3" sx={{ fontSize: "14px", fontWeight: 400 }}>
      Template
    </Typography>,
  ];

  const ListofDropdown = dropdownListQuery?.data?.drop_down_list; //day week month

  const WeekOfMonth = dropdownListQuery?.data?.Week_Number_List; //first second...

  const MonthDropdown = dropdownListQuery?.data?.Month_List; //jan feb mar

  const WeekDays = dropdownListQuery?.data?.week_values; // sun mon tue

  const TemplateTitle = ({ state, templates, templateDetails }) => {
    const getTitle = () => {
      const isEditMode =
        !state.isCreate &&
        !templates.isCreateDateAssign &&
        !templates.isCreateStoreAssign;
      if (templates.isShowErrorMessage) {
        return "Adjust Product Quantities";
      } else {
        if (isEditMode) {
          return templateDetails?.data?.template_name || "Generate Template";
        } else {
          return templates?.data?.template_name || "Generate Template";
        }
      }
    };

    return (
      <Typography fontWeight={500} fontSize="20px" px="8px">
        {getTitle()}
      </Typography>
    );
  };

  const renderTableFooter = () => {
    if (templates.isShowErrorMessage) {
      return (
        <Stack
          sx={{ gap: "12px", padding: "12px" }}
          direction="row"
          justifyContent="flex-end"
        >
          <Button
            key="cancel"
            variant="outlined"
            onClick={() => handleOpenClick(false)}
            sx={{
              height: "36px",
              border: "1px solid #BCC7DB",
              borderRadius: "10px",
              color: "#000000",
              bgcolor: "#F5F8FC",
            }}
          >
            Cancel
          </Button>
          {templates.isCreateDateAssign ? (
            <Button
              key="generate"
              variant="contained"
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
              }}
              disabled={createTemplateName?.isPending}
              onClick={() => {
                !isStoreAdmin
                  ? templates.is_create_date_assign === 1
                    ? handleSubmit(
                        true,
                        state?.templateDetails?.data?.template_id
                      )
                    : handleNextButton()
                  : templates.is_create_date_assign === 1
                    ? handleSubmit(
                        true,
                        state?.templateDetails?.data?.template_id
                      )
                    : handleClickUpdateOpen(
                        false,
                      state?.templateDetails?.data?.template_id
                      );
              }}
              startIcon={
                createTemplateName?.isPending ? (
                  <CircularProgress size={20} color="inherit" />
                ) : null
              }
            >
              {isStoreAdmin
                ? "Save"
                : templates.is_create_date_assign === 1
                  ? "Next"
                  : "Skip & Next"}
            </Button>
          ) : (
            <Button
              key="generate"
              variant="contained"
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
              }}
              disabled={
                createTemplateName?.isPending || hasAnyBatchError(templates)
              }
              onClick={() => {
                hasLastBatchWeightZero({ templates, type: "secondary" });
              }}
              startIcon={
                createTemplateName?.isPending ? (
                  <CircularProgress size={20} color="inherit" />
                ) : null
              }
            >
              Proceed
            </Button>
          )}
        </Stack>
      );
    } else {
      if (
        !state.isCreate &&
        !templates.isCreateDateAssign &&
        !templates.isCreateStoreAssign
      ) {
        return (
          <Stack
            direction="row"
            justifyContent="flex-end"
            spacing={2}
            padding="10px"
            marginTop="auto"
          >
            <Box sx={{ alignContent: "center" }}>
              <FormHelperText sx={{ color: "#C60808" }}>
                {validator.current.message(
                  "Recipe field",
                  batchFilter1,
                  "Item"
                )}
              </FormHelperText>
            </Box>
            <Button
              key="cancel"
              variant="outlined"
              color="gray"
              onClick={() => handleOpenClick(false)}
            >
              Cancel
            </Button>
            <Button
              key="generate"
              variant="contained"
              disabled={generateBatch?.isPending || copyBatch?.isPending}
              onClick={() => onCreateSubmit("initial")}
              startIcon={
                generateBatch?.isPending || copyBatch?.isPending ? (
                  <CircularProgress size={20} color="inherit" />
                ) : null
              }
            >
              Generate Batches
            </Button>
          </Stack>
        );
      } else if (templates.isCreateStoreAssign && !isStoreAdmin) {
        return (
          <Stack
            direction="row"
            justifyContent="space-between"
            padding="10px"
            alignItems="center"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography>Set Template Name:</Typography>
              <TextField
                variant="outlined"
                name="template_name"
                required
                disabled={
                  state.isDuplicate ||
                  templates.isCreateStoreAssign ||
                  templates.isCreateDateAssign
                }
                value={templates.data.template_name}
                onChange={onChange}
                sx={{
                  borderRadius: "10px",
                  height: "36px",
                  width: "405px",
                  "& .MuiOutlinedInput-root": {
                    minHeight: "32px",
                    width: "405px",
                    borderRadius: "10px",
                  },
                }}
                error={
                  validator.current.message(
                    "Template Name",
                    templates.data.template_name,
                    "required"
                  )
                    ? true
                    : false
                }
                helperText={validator.current.message(
                  "Template Name",
                  templates.data.template_name,
                  "required"
                )}
              />
            </Stack>
            <Stack sx={{ gap: "8px" }} direction="row">
              <Button
                key="cancel"
                variant="outlined"
                onClick={() => handleOpenClick(false)}
                sx={{
                  height: "36px",
                  border: "1px solid #BCC7DB",
                  borderRadius: "10px",
                  color: "#000000",
                  bgcolor: "#F5F8FC",
                }}
              >
                Cancel
              </Button>
              <Button
                key="generate"
                variant="contained"
                sx={{
                  height: "36px",
                  border: "1px solid #BCC7DB",
                  borderRadius: "10px",
                }}
                onClick={() => {
                  templates.selectedStores.length > 0
                    ? handleAlertClickOpen(
                        true,
                        state?.templateDetails?.data?.template_id
                      )
                    : isStoreAdmin
                      ? navigate(
                          `/store-admin/templates/details/${state?.templateDetails?.data?.template_id}`
                        )
                      : navigate(
                          `/templates/details/${state?.templateDetails?.data?.template_id}`
                        );
                }}
              >
                Save
              </Button>
            </Stack>
          </Stack>
        );
      } else {
        return (
          <Stack
            direction="row"
            justifyContent="space-between"
            padding="12px"
            alignItems="center"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography>Set Template Name:</Typography>
              <TextField
                variant="outlined"
                name="template_name"
                required
                disabled={
                  state.isDuplicate ||
                  templates.isCreateDateAssign ||
                  templates.isCreateStoreAssign
                }
                value={templates.data.template_name}
                onChange={onChange}
                sx={{
                  borderRadius: "10px",
                  height: "36px",
                  width: "405px",
                  "& .MuiOutlinedInput-root": {
                    minHeight: "28px",
                    width: "405px",
                    borderRadius: "10px",
                  },
                }}
                error={
                  validator.current.message(
                    "Template Name",
                    templates.data.template_name,
                    "required"
                  )
                    ? true
                    : false
                }
                helperText={validator.current.message(
                  "Template Name",
                  templates.data.template_name,
                  "required"
                )}
              />
            </Stack>
            <Stack sx={{ gap: "8px" }} direction="row">
              <Button
                key="cancel"
                variant="outlined"
                color="gray"
                onClick={() => handleOpenClick(false)}
              >
                Cancel
              </Button>
              {templates.isCreateDateAssign ? (
                <Button
                  key="generate"
                  variant="contained"
                  sx={{
                    height: "36px",
                    border: "1px solid #BCC7DB",
                    borderRadius: "10px",
                  }}
                  disabled={createTemplateName?.isPending}
                  onClick={() => {
                    if (!isStoreAdmin) {
                      if (templates.is_create_date_assign === 1) {
                        handleSubmit(
                          true,
                          state?.templateDetails?.data?.template_id
                        );
                      } else {
                        handleNextButton();
                      }
                    } else {
                      if (templates.is_create_date_assign === 1) {
                        handleSubmit(
                          true,
                          state?.templateDetails?.data?.template_id
                        );
                      } else {
                        setTemplates((draft) => {
                          draft.isOpen = false;
                        });
                        navigate(
                          `/store-admin/templates/details/${state?.templateDetails?.data?.template_id}`
                        );
                      }
                    }
                  }}
                  startIcon={
                    createTemplateName?.isPending ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : null
                  }
                >
                  {isStoreAdmin
                    ? "Save"
                    : templates.is_create_date_assign === 1
                      ? "Next"
                      : "Skip & Next"}
                </Button>
              ) : (
                <Button
                  key="generate"
                  variant="contained"
                  sx={{
                    height: "36px",
                    border: "1px solid #BCC7DB",
                    borderRadius: "10px",
                  }}
                  disabled={createTemplateName?.isPending}
                  onClick={() => {
                    state.isDuplicate
                      ? navigateBasedOnUserType(
                          `/templates/details/${state?.templateDetails?.data?.template_id}`,
                          isStoreAdmin,
                          navigate
                        )
                      : onSubmit();
                  }}
                  startIcon={
                    createTemplateName?.isPending ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : null
                  }
                >
                  Generate
                </Button>
              )}
            </Stack>
          </Stack>
        );
      }
    }
  };

  const renderContent = (globalData) => {
    if (
      templates.isShowErrorMessage &&
      !state.isCreate &&
      !templates.isCreateDateAssign &&
      !templates.isCreateStoreAssign
    ) {
      return (
        <BatchSplitDialog
          templates={templates}
          setTemplates={setTemplates}
          handleBatchSplitUpdate={handleBatchSplitUpdate}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          setEditedMap={setEditedMap}
          setFocusedField={setFocusedField}
          editedMap={editedMap}
          focusedField={focusedField}
          updateBatchSplit={updateBatchSplit}
          handleAddBatch={handleAddBatch}
          handleDeleteBatch={handleDeleteBatch}
          handleDeleteBatchDialog={handleDeleteBatchDialog}
          globalData={globalData}
          hasLastBatchWeightZero={hasLastBatchWeightZero}
        />
      );
    } else {
      if (
        !state.isCreate &&
        !templates.isCreateDateAssign &&
        !templates.isCreateStoreAssign
      ) {
        return (
          <GenerateTemplates
            templates={templates}
            categorylistQuery={categorylistQuery}
            handleRecipes={handleRecipes}
            onChangeFilter={onChangeFilter}
            updateTableData={updateTableData}
            onSearchChange={onSearchChange}
            handleCustomTableChange={handleCustomTableChange}
            searchHandler={searchHandler}
            handleCustomFieldChange={handleCustomFieldChange}
            recipelistQuery={recipelistQuery}
            validator={validator}
            templateDetails={templateDetails}
          />
        );
      } else if (
        state.isCreate &&
        !templates.isCreateDateAssign &&
        !templates.isCreateStoreAssign
      ) {
        return (
          <CommonTab
            state={state.templateDetails}
            templates={templates}
            handleOptionChangeRecipeBatch={handleOptionChangeRecipeBatch}
            handleOptionChangeRecipe={handleOptionChangeRecipe}
            globalData={globalData}
            setTemplates={setTemplates}
          />
        );
      } else if (templates.isCreateDateAssign) {
        return (
          <CreateDateAssignTab
            templates={templates}
            onChangeMultipleDate={onChangeMultipleDate}
            onSaveCustomDays={onSaveCustomDays}
            onDeleteTagSelect={onDeleteTagSelect}
            WeekDays={WeekDays}
            handleRepeatOptionChange={handleRepeatOptionChange}
            ListofDropdown={ListofDropdown}
            onChangeHandler={onChangeHandler}
            RadioButtonChange={RadioButtonChange}
            handleDayClick={handleDayClick}
            MonthDropdown={MonthDropdown}
            monthOptionChange={monthOptionChange}
            WeekOfMonth={WeekOfMonth}
            weekOfMonthOptionChange={weekOfMonthOptionChange}
            weekDaysOptionChange={weekDaysOptionChange}
            onChangeYear={onChangeYear}
            onChangeSceduler={onChangeSceduler}
            onChangeDate={onChangeDate}
            DaysOfWeekOptionChange={DaysOfWeekOptionChange}
            OptionChange={OptionChange}
            WeekDaysOptionChange={WeekDaysOptionChange}
            handleCreateDateAssign={handleCreateDateAssign}
            validator={dateValidator}
          />
        );
      } else if (templates.isCreateStoreAssign && !isStoreAdmin) {
        return (
          <CreateStoreAssignTab
            storeListData={storeListData}
            templates={templates}
            state={state}
            handleStoreAssignDialog={handleStoreAssignDialog}
            handleAlertClickOpen={handleAlertClickOpen}
            setTemplates={setTemplates}
          />
        );
      }
    }
  };

  return (
    <>
      {validator.current.purgeFields()}
      <PageListLayout breadcrumbs={breadcrumbs} sx={{ p: "0x", pb: 1 }}>
        <ServerPaginatedtable
          defaultData={listQuery?.data?.templates}
          columns={columns}
          headerText="Template"
          search={search}
          sorting={sorting}
          setSorting={(callback) =>
            setSorting({ tableName: moduleName, callback })
          }
          pagination={pagination}
          setPagination={(callback) =>
            setPagination({ tableName: moduleName, callback })
          }
          paginationProps={
            listQuery.data?.pagination || { total: 0, lastPage: 1 }
          }
          onSearchChange={onSearchHandler}
          isLoading={isLoading}
          onRowLink={(e) => {
            return `details/${e.template_id}`;
          }}
          tableHeaderContent={
            <>
              <Stack
                sx={{
                  flexDirection: "row",
                  gap: "6px",
                  width: "100%",
                }}
              >
                <InputControl
                  type="dropdown"
                  variant="filter"
                  size="small"
                  options={selectStatus.statusOptions}
                  getOptionLabel={(option) => option?.name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  sx={{
                    width: "180px",
                  }}
                  value={
                    selectStatus?.statusOptions?.find(
                      (option) =>
                        option.id === tableData.templates.data.selectedStatus
                    ) || null
                  }
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Status" />
                  )}
                  onChange={(event, option) =>
                    selectStatus.statusValueChangeHandler(option)
                  }
                />
                {!isStoreAdmin && (
                  <InputControl
                    type="dropdown"
                    variant="filter"
                    size="small"
                    fullWidth
                    multiple={true}
                    options={storeLists?.data || []}
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    disableCloseOnSelect
                    sx={{
                      width: "250px",
                    }}
                    renderTags={(value) => (
                      <LimitedTag value={value} autocompleteWidth="250px" />
                    )}
                    value={tableData?.templates?.data?.storefilter}
                    onChange={(event, option) =>
                      StoreValuesHandler(event, option)
                    }
                    renderOption={(props, option, { selected }) => (
                      <>
                        <li {...props} key={option.id}>
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      </>
                    )}
                    filterOptions={filter}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Store" />
                    )}
                  />
                )}
                <InputControl
                  type="dropdown"
                  variant="filter"
                  size="small"
                  options={selectSchedule?.sceduleOptions}
                  value={
                    selectSchedule?.sceduleOptions?.find(
                      (scedule) =>
                        scedule?.id ===
                        tableData?.templates?.data?.selectedSchedule
                    ) || null
                  }
                  getOptionLabel={(option) => option?.name || ""}
                  onChange={(event, option) =>
                    selectSchedule.sceduleValueChangeHandler(option)
                  }
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  sx={{
                    width: "230px",
                    gap: "8px",
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Scheduled" />
                  )}
                />
                <Button
                  type="button"
                  size="small"
                  variant="text"
                  sx={{
                    p: "6px 12px 6px 12px",
                    gap: "6px",
                  }}
                  disabled={disableclearButton}
                  onClick={onClearFilter}
                >
                  Clear All
                </Button>
              </Stack>
            </>
          }
          rightContent={
            <Stack direction="row" gap="8px">
              {isCreateVisible && (
                <Button
                  sx={{
                    height: "36px",
                    border: "1px solid #BCC7DB",
                    borderRadius: "10px",
                  }}
                  type="button"
                  size="medium"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenClick(true)}
                >
                  New Template
                </Button>
              )}
            </Stack>
          }
        />
      </PageListLayout>

      {deleteInfo.show && (
        <DeleteModal
          open={deleteInfo.show}
          handleClose={() => resetDeleteInfo()}
          onConfirm={() => confirmDelete()}
        />
      )}

      {(deleteInfo.showTemp || templates.isDeleteScheduledDatesDialogOpen) && (
        <DeleteAlertDialog
          key={allDates}
          open={deleteInfo.showTemp}
          isDeleteScheduledDatesDialogOpen={
            templates.isDeleteScheduledDatesDialogOpen
          }
          resetDeleteInfo={resetDeleteInfo}
          handleDeleteScheduledDatesDialog={handleDeleteScheduledDatesDialog}
          dropdownListQuery={dropdownListQuery}
          globalData={globalData}
          templateProductionDaysDetails={templateProductionDaysDetails}
          confirmDelete={confirmDelete}
          templateDetails={templateDetails}
          isScheduledOrDelete={templates.isDeleteScheduledDatesDialogOpen}
          selectedDates={selectedDates}
          setSelectedDates={setSelectedDates}
          allDates={allDates}
          allProductionDates={allProductionDates}
          selectedProductionDates={selectedProductionDates}
          setSelectedProductionDates={setSelectedProductionDates}
          unselectedProductionDates={unselectedProductionDates}
          setUnselectedProductionDates={setUnselectedProductionDates}
          templateProductionDaysList={templateProductionDaysList}
        />
      )}

      <CustomeDialog
        PaperProps={{
          sx: {
            minWidth: "570px",
            minHeight: "280px",
            borderRadius: "10px",
          },
        }}
        open={templates?.isScheduleUpdateOpen}
        handleClose={() =>
          handleClickUpdateOpen(
            false,
            state?.templateDetails?.data?.template_id,
            true
          )
        }
        title={
          <Typography
            sx={{
              padding: "20px 20px 8px 20px",
              fontWeight: "500",
              fontSize: "20px",
              lineHeight: "24.2px",
              width: "590px",
            }}
          >
            From when should this template change be applied to generated
            production charts?
          </Typography>
        }
        content={
          <RegenerateDialog
            onSubmit={onSubmits}
            templates={templates}
            onChangeEffectiveDate={onChangeEffectiveDate}
            setTemplates={setTemplates}
            handleClose={() => handleClickUpdateOpen(false)}
            state={templates}
          />
        }
      />

      <CustomDialogTemplate
        open={templates.isOpen}
        handleBack={handleBack}
        PaperProps={{
          sx: {
            minWidth: "80vw",
            height: "90vh",
          },
        }}
        title={
          <TemplateTitle
            state={state}
            templates={templates}
            templateDetails={templateDetails}
          />
        }
        isBackArroaw={
          state.isCreate ||
          templates.isCreateDateAssign ||
          templates.isCreateStoreAssign
        }
        content={renderContent(globalData)}
        tableFooter={renderTableFooter()}
      />
    </>
  );
};
